import { jsx } from 'react/jsx-runtime';
import { BaseCellWrapper } from './styles.js';

const BaseCell = ({
  children,
  divider,
  className,
  ...props
}) => jsx(BaseCellWrapper, Object.assign({
  className: className,
  divider: divider
}, props, {
  children: children
}), void 0);
BaseCell.displayName = 'BaseCell';

export { BaseCell };
